import axios from "axios";

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "/",
});

// Attach the user's currently-active role so the backend can narrow
// authorization to that role (multi-role users acting as a single role).
instance.interceptors.request.use((config) => {
  try {
    const activeRole = localStorage.getItem("activeRole");
    if (activeRole) {
      config.headers = config.headers || {};
      config.headers["X-Active-Role"] = activeRole;
    }
  } catch (e) {
    /* ignore */
  }
  return config;
});

// Global handler: if the session is invalid/expired or the account has been
// deactivated, clear local auth and send the user back to the login page.
let redirecting = false;
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const code = error?.response?.data?.code;

    const isAuthFailure =
      status === 401 ||
      (status === 403 && code === "ACCOUNT_INACTIVE");

    // Don't redirect for the login request itself (let the page show the error).
    const url = error?.config?.url || "";
    const isAuthEndpoint = url.includes("/auth/");

    if (isAuthFailure && !isAuthEndpoint && !redirecting) {
      redirecting = true;
      try {
        localStorage.clear();
      } catch (e) {
        /* ignore */
      }
      // Full reload to reset all app state, landing on the login page ("/").
      if (window.location.pathname !== "/") {
        window.location.replace("/");
      } else {
        window.location.reload();
      }
    }

    return Promise.reject(error);
  }
);

export default instance;
